import {useMutation, useQueryClient} from "@tanstack/react-query";
import {IErrorClassifierErrorKey, IErrorClassifierErrorKeyForm} from "../../../../../store/errorClassifier/types";
import {ErrorClassifierService} from "../../../../../services/error_classifier.service";

export function useUpdateErrorKey(id: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: IErrorClassifierErrorKeyForm) => ErrorClassifierService.updateErrorKey(id, data),

        onMutate: async (updatedData) => {
            await queryClient.cancelQueries({queryKey: ["keyErrorClassifierErrorKeys"]});

            const previousKeys = queryClient.getQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"]);

            queryClient.setQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"], (old) =>
                old?.map((key) => (key.id === id ? {...key, ...updatedData} : key)) ?? []
            );

            return {previousKeys};
        },

        onError: (err, newData, context) => {
            if (context?.previousKeys) {
                queryClient.setQueryData(["keyErrorClassifierErrorKeys"], context.previousKeys);
            }
        },

        onSuccess: (savedItem) => {
            queryClient.setQueryData<IErrorClassifierErrorKey[]>(["keyErrorClassifierErrorKeys"], (old) =>
                old?.map((key) => (key.id === savedItem.id ? savedItem : key)) ?? []
            );
        },
    });
}
